import { motion } from "framer-motion";
import { useLang } from "../../i18n/LangContext";

export const LangToggle = ({ id = "desktop" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className="relative flex rounded-full border border-[#D6CEBF] p-1 font-mono text-xs" role="group" aria-label="Lingua / Language">
      {["it", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-toggle-${l}${id === "mobile" ? "-mobile" : ""}`}
          aria-pressed={lang === l}
          className={`relative z-10 h-8 w-10 rounded-full uppercase tracking-widest transition-colors duration-300 ${lang === l ? "text-[#FBF9F5]" : "text-stone-600 hover:text-[#1C1917]"}`}
        >
          {lang === l && (
            <motion.span layoutId={`lang-pill-${id}`} className="absolute inset-0 -z-10 rounded-full bg-[#1C1917]" transition={{ type: "spring", stiffness: 400, damping: 32 }} />
          )}
          {l}
        </button>
      ))}
    </div>
  );
};
